import { format } from 'date-fns';

import downloadXLS from 'utils/downloadXLS';
import { fetchAllIncentiveOfferOperations } from 'modules/incentivesMarket/api/fetchAllIncentiveOfferOperations';
import { IncentiveOfferType } from 'modules/incentivesMarket/types';

import { buildIncentiveOfferOperationsXlsxData } from './buildIncentiveOfferOperationsXlsxData';

const sanitizeFileName = (value: string) =>
  value
    .replace(/[^\w\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-') || 'operations';

type DownloadIncentiveOfferOperationsXlsxProps = {
  incentiveOfferId: string;
  societyId: string;
  offerReference: string;
  offerType: IncentiveOfferType;
  t: (key: string) => string;
};

export const downloadIncentiveOfferOperationsXlsx = async ({
  incentiveOfferId,
  societyId,
  offerReference,
  offerType,
  t,
}: DownloadIncentiveOfferOperationsXlsxProps) => {
  const operations = await fetchAllIncentiveOfferOperations({
    incentiveOfferId,
    societyId,
  });

  const xlsxData = buildIncentiveOfferOperationsXlsxData({
    operations,
    offerType,
    t,
  });

  const fileName = `${sanitizeFileName(offerReference)}-${sanitizeFileName(
    t('OperationStatus')
  )}.xlsx`;

  downloadXLS(xlsxData, fileName, format(new Date(), 'yyyy-MM-dd'));
};
